export var createTrustedTypesPolicy = function (policyName) {
    var _a;
    var ttWindow = window;
    var trustedTypePolicy;
    var validCdnUrls = [
        'https://res.sdf.cdn.office.net',
        'https://res-3.cdn.partner.office365.cn',
        'https://res-1-gcch.cdn.office.net',
        'https://res-1-dod.cdn.office.net',
        'https://res-1-cdn.azureedge.microsoft.scloud',
        'https://res-1-cdn.azureedge.eaglex.ic.gov',
        'https://res-2-dev.cdn.officeppe.net',
        'https://res-2-h3.sdf.cdn.office.net',
        'https://res-2-h3.public.cdn.office.net',
        'https://res-2-gcch.cdn.office.net',
        'https://res-2-dod.cdn.office.net',
        'https://res-4.cdn.partner.office365.cn',
        'https://res-dev.cdn.officeppe.net',
        'https://res.cdn.office.net',
        'https://localcdn.centro-dev.com:5555',
        // OCDI urls
        'https://res.public.onecdn.static.microsoft',
        'https://res.df.onecdn.static.microsoft',
        'https://res-cn.cdn.partner.office365.cn',
        'https://res-dod.cdn.office.net',
        'https://res-gcc.cdn.office.net',
        'https://res-gcch.cdn.office.net',
        'https://res-1-cdn.azureedge.microsoft.scloud',
        'https://res-1-cdn.azureedge.eaglex.ic.gov',
    ];
    if ((_a = ttWindow === null || ttWindow === void 0 ? void 0 : ttWindow.trustedTypes) === null || _a === void 0 ? void 0 : _a.createPolicy) {
        try {
            trustedTypePolicy = ttWindow.trustedTypes.createPolicy(policyName, {
                createScriptURL: function (url) {
                    var parseUrl;
                    try {
                        parseUrl = new URL(url);
                    }
                    catch (error) {
                        throw new Error("Invalid script url " + url);
                    }
                    if ((parseUrl === null || parseUrl === void 0 ? void 0 : parseUrl.protocol) !== 'https:') {
                        throw new Error("Only https protocol is allowed for script url " + url);
                    }
                    if ((parseUrl === null || parseUrl === void 0 ? void 0 : parseUrl.origin) && !validCdnUrls.includes(parseUrl === null || parseUrl === void 0 ? void 0 : parseUrl.origin)) {
                        throw new Error("Loading a script from " + url + " is not allowed because the domain is not in the list of trusted domains");
                    }
                    return url;
                },
                createScript: undefined,
                createHTML: undefined,
            });
        }
        catch (error) {
            console.error('Failed to create trusted type policy', error);
        }
    }
    return trustedTypePolicy;
};
